import React, { useContext } from "react";
import { Datagrid, List, TextField, TextInput } from "react-admin";
import { AppContext } from "../../providers/app-context-provider/app.context";
import { ProfileEnum } from "../../utils/general-profile.enum";

const ClientList = (props) => {

    const context = useContext(AppContext)
    const filters = [<TextInput label='Nome' source='name' alwaysOn />,]
    return (
        <List exporter={false} bulkActionButtons={false}
            title={'Clientes'}
            {...props}
            filters={filters}
        >
            <Datagrid rowClick={'edit'}>
                <TextField source="name" label={'Nome'} />
                <TextField source="phone" label={'Telefone'} />
                <TextField source="email" label={'Email'} />
                {context.profile.name === ProfileEnum.SUPERADMIN && <TextField source="institution_branch.institution.name" label={'Instituição'} />}
                {(context.profile.name === ProfileEnum.SUPERADMIN || context.profile.name === ProfileEnum.GENERAL_PRINCIPAL) && <TextField source="institution_branch.name" label={'Unidade'} />}
            </Datagrid>
        </List>
    )
}

export default ClientList;